<div id="header-wr" class="px-4 pb-1 pt-1">
  <div class="flex items-center header-bar">
    <div class="w-full header-left">
      <!-- Toggle sidebar button -->
      <span>
        <button data-testid="header-toggle-sidebar-btn" class="reset-btn" tabindex="0" (click)="toggleSidebar()">
          <img data-testid="header-toggle-sidebar-icon" src="../../../../../assets/icons/toggle-menu.svg">
        </button>
      </span>
      <!-- /Toggle sidebar button -->
    </div>

    <div class="shrink-0 header-controls" [class.pr-4]="!isOtpTransparentLogin" [class.border-r-1]="!isOtpTransparentLogin" [class.otp-login]="isOtpTransparentLogin">
      <div class="flex items-center gap-4 header-dropdowns">
        <div class="flex items-center min-h-full text-sm gap-2 header-dropdown">
          @if (canSwitchCompanies) {
            <app-custom-dropdown
              data-testid="header-company-dropdown"
              class="customers-dropdown"
              [compactUi]="true"
              [searchPlaceholder]="'DROPDOWN.SEARCH_PLACEHOLDER' | translate"
              [placeholder]="'DROPDOWN.PLACEHOLDER' | translate"
              [options]="customersListDropdown"
              [pageSize]="10"
              optionLabel="text"
              optionValue="id"
              [isMultiselect]="false"
              [showSelectionChips]="true"
              [showSearchbox]="true"
              [showClear]="false"
              [searchMode]="'local'"
              [ngModel]="activeCompany"
              (ngModelChange)="onCustomersListDropdownChange($event)">
            </app-custom-dropdown>
          }
        </div>

        <div class="flex items-center min-h-full text-sm gap-2 header-dropdown">
          <ng-container>
            <app-custom-dropdown
              data-testid="header-language-dropdown"
              class="languages-dropdown"
              [compactUi]="true"
              [options]="languages"
              [pageSize]="12"
              optionLabel="language"
              optionValue="code"
              [translateOptionLabel]="true"
              [isMultiselect]="false"
              [showSelectionChips]="true"
              [showSearchbox]="false"
              [showClear]="false"
              [searchMode]="'local'"
              [ngModel]="selectedLanguageValues"
              (ngModelChange)="onLanguageChange($event)">
            </app-custom-dropdown>
          </ng-container>
        </div>
      </div>

      <!-- Notifications -->
      <!-- Notifications -->
      <p-popover #notifications styleClass="notifications-dropdown-wr">
        <ul class="notifications-list">
          <li class="flex-1 pt-2 pb-2 notification">
            <p class="text-base text-sm">Sales exported!</p>
            <p class="text-sm date">24-06-2024</p>
          </li>

          <li class="flex-1 pt-2 pb-2 notification">
            <p class="text-base text-sm">Items exported!</p>
            <p class="text-sm date">24-06-2024</p>
          </li>

          <li class="flex-1 pt-2 pb-2 notification">
            <p class="text-base text-sm">Products exported!</p>
            <p class="text-sm date">24-06-2024</p>
          </li>
        </ul>
      </p-popover>
      <!-- /Notifications -->
    </div>

    @if (!isOtpTransparentLogin) {
      <div class="shrink-0 py-2 pl-2 pr-0 header-user">
        <div class="flex items-center min-h-full text-sm gap-2"
          data-testid="header-user-menu-btn"
          (click)="profileDropdown.toggle($event)">
          <div data-testid="header-user-avatar" class="flex items-center rounded-full text-center" id="user-avatar">
            <span class="sr-only">{{ 'CORE_HEADER.OPEN_USER_MENU' | translate }}</span>
            <span data-testid="header-user-initials" class="initials">{{ userCredentials }}</span>
          </div>
          <div class="flex flex-col ml-1">
            <span data-testid="header-username" class="username truncate">{{ userName }}</span>
            <span data-testid="header-user-role" class="role">{{ userRoles }}</span>
          </div>
          <div class="icon-wr caret">
            <svg data-testid="header-user-caret-icon"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="#95A1B8" aria-hidden="true"
              data-slot="icon">
              <path
                d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z">
              </path>
            </svg>
          </div>
          <!-- Profile dropdown -->
          <p-popover #profileDropdown styleClass="profile-dropdown-wr">
            <ul data-testid="header-profile-dropdown" class="profile-dropdown-list text-sm">
              <li data-testid="header-profile-account" class="flex items-center gap-2 pt-2 pr-2 pb-2 pl-2 bottom-divider"
                (click)="closePrimaryDropdown(profileDropdown)" [routerLink]="['your-account']">
                <i class="icon icon-account"></i>
                <span class="text-base font-medium">
                  {{ 'CORE_HEADER.MY_ACCOUNT' | translate }}
                </span>
              </li>
              <li data-testid="header-profile-terms" class="flex items-center gap-2 pt-2 pr-2 pb-2 pl-2"
                (click)="closePrimaryDropdown(profileDropdown)" [routerLink]="['terms-and-conditions']">
                <i class="icon icon-terms"></i>
                <span class="text-base font-medium">
                  {{ 'CORE_HEADER.TERMS_CONDITIONS' | translate }}
                </span>
              </li>
              <li data-testid="header-profile-privacy" class="flex items-center gap-2 pt-2 pr-2 pb-2 pl-2"
                (click)="closePrimaryDropdown(profileDropdown)" [routerLink]="['privacy-policy']">
                <i class="icon icon-policy"></i>
                <span class="text-base font-medium">
                  {{ 'CORE_HEADER.PRIVACY_POLICY' | translate }}
                </span>
              </li>
              <li data-testid="header-profile-signout" class="flex items-center gap-2 pt-2 pr-2 pb-2 pl-2 top-divider"
                (click)="signOut()">
                <i class="icon icon-signout"></i>
                <span class="text-base font-medium">
                  {{ 'CORE_HEADER.SING_OUT' | translate }}
                </span>
              </li>
            </ul>
          </p-popover>
          <!-- /Profile dropdown -->
        </div>
      </div>
    }
  </div>
</div>
